import Menu from '../Menu';
import { connect } from 'react-redux';
import { IStoreState } from 'src/store';
import { FrameworkActionCreator, AppointmentActionCreator, AdditionalServicesActionCreator, CustomerActionCreator, WebOpsActionCreator, VehiclesActionCreator } from 'src/store/states';
import { BlankDeptSpec } from 'src/models/Specs/TestSpecs';

const mapStateToProps = (state: IStoreState) => {
    const specData = state.Specs.specs;
    const appointment = state.Appointment.Appointment;
    const apptCust = state.Appointment.ApptCust;
    const apptVeh = state.Appointment.ApptVeh;
    // const advisors = state.Specs.specs?.Advisors;
    const advisors = state.Specs.deptSpecs?.Advisors !== undefined ?
        state.Specs.deptSpecs.Advisors : [];
    const apptOps = state.Appointment.ApptOps;
    const vehiclePhoto = state.Vehicles.vehiclePhoto;
    const theme = state.Framework.theme;
    const mainPaneViewOrder = state.Framework.mainPaneViewOrder;
    const deptSpecs = state.Specs.deptSpecs !== undefined ? state.Specs.deptSpecs : BlankDeptSpec;
    const errMsg = state.Customer.errMsg !== undefined ? state.Customer.errMsg : '';
    const retCode = state.Customer.retCode !== undefined ? state.Customer.retCode : '';
    const specProfile = state.Framework.specProfile;
    const store = state.Framework.store;
    const branch = state.Framework.branch;
    const customerInfo = state.Customer.Customer;
    const previewFlag= state.Framework.previewFlag;
    const changeCustReturned = state.Customer.changeCustReturned;
    const locale = state.Framework.locale;
    const allServices = state.AdditionalServices.allServices;
    const profileOpen = state.Framework.profileOpen;
    const newVehicleMileage = state.NewVehicle.NewVehicle?.estMileage!;
    const prevMileage = state.Vehicles.selectedVehicle !== 'AddVehicle' && state.Vehicles.selectedVehicle &&
        state.Vehicles.selectedVehicle !== '' && state.Vehicles.selectedVehicle !== '-1' && state.Vehicles &&
        state.Vehicles.vehicles[state.Vehicles.selectedVehicle!] ?
        state.Vehicles.vehicles[state.Vehicles.selectedVehicle!].prevMileage : 0;
    const identityVerified = state.Customer.identityVerified ?? false;
    const vehicleList = state.Vehicles.vehicles;
    const selectedVehicle = state.Vehicles.selectedVehicle ?? '';
    const lexusMCLaunched = state.Framework.lexusMCLaunched ?? '';
    const toyotaMCLaunched = state.Framework.toyotaMCLaunched ?? '';
    const employeeFlag = state.Customer.Customer.employeeFlag ?? false;
    const noAutoRecall = state.Framework.noAutoRecall;
    const desktopOrMobile = state.Framework.desktopOrMobile;
    const Itype = state.Framework.ImageServerType;
    const countryCode = state.Framework.dealerCountry;
    const lexusTDMCLaunched = state.Framework.lexusTDMCLaunched ?? '';
    const toyotaTDMCLaunched = state.Framework.toyotaTDMCLaunched ?? '';
    const vwDeepLinkMileage = state.Framework.vwDeepLinkMileage;
    const vwVariant = state.Framework.vwVariant;
    const vwKeyword = state.Framework.vwKeyword;
    const vwProvider = state.Framework.vwProvider;
    const sessionId = state.Framework.sessionId;
    const appointmentState = state.Appointment;

    return {
        appointment: appointment,
        apptCust: apptCust,
        apptVeh: apptVeh,
        advisors: advisors,
        apptOps: apptOps,
        vehiclePhoto: vehiclePhoto,
        theme: theme,
        mainPaneViewOrder: mainPaneViewOrder,
        deptSpecs: deptSpecs,
        errMsg: errMsg,
        retCode: retCode,
        specProfile: specProfile,
        store: store,
        branch: branch,
        customerInfo: customerInfo,
        previewFlag: previewFlag,
        changeCustReturned: changeCustReturned,
        locale: locale,
        allServices: allServices,
        profileOpen: profileOpen,
        newVehicleMileage: newVehicleMileage,
        prevMileage: prevMileage,
        identityVerified: identityVerified,
        vehicleList: vehicleList,
        selectedVehicle: selectedVehicle,
        employeeFlag: employeeFlag,
        noAutoRecall: noAutoRecall,
        desktopOrMobile: desktopOrMobile,
        Itype: Itype,
        countryCode: countryCode,
        vwDeepLinkMileage: vwDeepLinkMileage,
        vwVariant: vwVariant,
        vwKeyword: vwKeyword,
        vwProvider: vwProvider,
        appointmentState: appointmentState,
        specData: specData,
        sessionId: sessionId,
        lexusMCLaunched: lexusMCLaunched,
        toyotaMCLaunched: toyotaMCLaunched,
        lexusTDMCLaunched: lexusTDMCLaunched,
        toyotaTDMCLaunched: toyotaTDMCLaunched,
    };
};

const mapDispatchToProps = {
    pushToMainPanes: FrameworkActionCreator.pushToMainPane,
    onApptCustUpdate: AppointmentActionCreator.UpdateApptCust,
    updateApptVehicle: AppointmentActionCreator.UpdateApptVehicle,
    changeCustInfo: CustomerActionCreator.ChangeCustInfo,
    onCustUpdate: CustomerActionCreator.UpdateCustInfo,
    clearError: CustomerActionCreator.CustomerClearError,
    checkUniqueEmail: CustomerActionCreator.CheckUniqueEmail,
    setChangeCustReturned: CustomerActionCreator.SetChangeCustReturned,
    clearAdditionalServices: AdditionalServicesActionCreator.ClearAdditionalServices,
    clearCheckedAdditionalServices: AdditionalServicesActionCreator.ClearCheckedAdditionalServices,
    clearCheckedWebOps: WebOpsActionCreator.ClearCheckedWebOps,
    setProfileOpen: FrameworkActionCreator.SetProfileOpen,
    selectVehicle: VehiclesActionCreator.SelectVehicle,
    setNoAutoRecall: FrameworkActionCreator.SetNoAutoRecall,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(Menu);